import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.55659 0.746262C9.94712 1.13679 9.94712 1.76995 9.55659 2.16048L4.42394 7.29313C4.03342 7.68365 3.40026 7.68365 3.00973 7.29313L0.443406 4.7268C0.0528816 4.33628 0.0528816 3.70311 0.443406 3.31259C0.83393 2.92206 1.4671 2.92206 1.85762 3.31259L3.71684 5.17181L8.14238 0.746262C8.53291 0.355738 9.16607 0.355738 9.55659 0.746262Z",
		fill: "black"
	})
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
